var Model = require('../Model');

var Level = Object.create(Model);

Level.name = 'Level';
Level['@class'] = 'Level';
Level.url = 'level';
Level.parentClass = 'Location';
Level.fields = {
	parent: {
    default: null,
    hidden: true
	},
  name:{
    type: 'text',
    default: null,
    validators: {
      presence: true, 
      length: {minimum: 1, maximum: 32, default: ''},
    }
  },
  floor:{
    type: 'number',
    default: '',
    validators: {
      presence: true,
    }
  },
  geojson:{
    type: 'text',
    default: null,
  },
  index: {
    default: null,
  },
  svg: {
    default: null,
    type: 'text',
  },
  defaultMapView: {
    default: null,
    type: 'text',
  }
}

module.exports = Level;
